import { FC } from 'react';

export const Section: FC = ({ children }) => {
    return (
        <div className='flex md:flex-row flex-col items-start gap-x-5 py-5'>
            {children}
        </div>
    );
};
